import postAPI from './postAPI.js'

export default async function postCompleteLastStep(body) {
    const data = await postAPI('admin/taskinstances/completelast', body);
    return data;
}
